"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ramda_1 = require("ramda");
const isSynonymField = (field) => {
    return !!field;
};
exports.getSynonymFields = ({ synonymId, synonymFields }) => {
    return ramda_1.values(synonymFields)
        .filter(isSynonymField)
        .filter(field => field.parentId === synonymId);
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0U3lub255bUZpZWxkcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9ldmFsdWF0b3IvZ2V0U3lub255bUZpZWxkcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUNBLGlDQUErQjtBQUcvQixNQUFNLGNBQWMsR0FBRyxDQUNyQixLQUF3QyxFQUNSLEVBQUU7SUFDbEMsT0FBTyxDQUFDLENBQUMsS0FBSyxDQUFDO0FBQ2pCLENBQUMsQ0FBQztBQUVXLFFBQUEsZ0JBQWdCLEdBQUcsQ0FBQyxFQUMvQixTQUFTLEVBQ1QsYUFBYSxFQUlkLEVBQUUsRUFBRTtJQUNILE9BQU8sY0FBTSxDQUFDLGFBQWEsQ0FBQztTQUN6QixNQUFNLENBQUMsY0FBYyxDQUFDO1NBQ3RCLE1BQU0sQ0FBQyxLQUFLLENBQUMsRUFBRSxDQUFDLEtBQUssQ0FBQyxRQUFRLEtBQUssU0FBUyxDQUFDLENBQUM7QUFDbkQsQ0FBQyxDQUFDIn0=